import { getThemeColorHexCode } from '../utils/getThemeColorHexCode';
import { store } from '../store/store';

export const getThemeColor = (): string => {
    const { themeId, isDarkTheme } = store;
    return getThemeColorHexCode(themeId, isDarkTheme);
};
